import { http } from 'services';

export const List = ({ params }) => http.request.post('/v1/gov-function/open-function/pageable', {
    per_page: params.perPage,
    page: params.page,
    sort: params.sort,
    search: params.filter
  });

export const Single = ({ id }) => http.request.get(`/v1/gov-function/open-function/${id}`);